import React, { useState } from "react"

const Accordion = ({ children }) => {
  return <div className="w-full">{children}</div>
}

const AccordionItem = ({ question, answer, faqImg }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="border-y border-gray-800">
      <button
        className={`flex justify-between items-center w-full p-4 text-left transition-colors duration-200 ${
          isOpen ? "bg-blue-50 text-[#0c63e4] font-bold text-xl" : "text-base"
        }`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className=" font-semibold">{question}</span>
        <span className="ml-6 flex-shrink-0">
          {isOpen ? <MinusIcon className="h-6 w-6" /> : <PlusIcon className="h-6 w-6" />}
        </span>
      </button>
      {isOpen && (
        <div className="p-4">
          <p className="text-[#212529] text-[20px] font-light">{answer}</p>

          {faqImg&&(
            <img src={faqImg} alt="img" className="w-full mt-2"/>
          )}
        </div>
      )}
    </div>
  )
}

const PlusIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
  </svg>
)

const MinusIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
  </svg>
)

export { Accordion, AccordionItem }

